module.exports = __webpack_public_path__ + "static/media/english_submission.f5619d50.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/english_submission.gif
// module id = 1140
// module chunks = 0